import { Close } from "@mui/icons-material";
import { Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";
import Box from "@mui/material/Box";

export default function FormModal({ form, title, open, handleClose }) {
  return (
    <Dialog fullWidth={true} open={open} onClose={handleClose}>
      <Box className="overflow-y-auto">
        <DialogTitle color="primary" className="w-full flex flex-row justify-between items-center bg-orange-100 mb-4">
          {title}
          <IconButton
            edge="start"
            color="inherit"
            onClick={() => {
              handleClose();
            }}
          >
            <Close color="primary" className="cursor-pointer" fontSize="medium" />
          </IconButton>
        </DialogTitle>
        <DialogContent className="overflow-y-hidden overflow-x-hidden w-full px-2">{form}</DialogContent>
      </Box>
    </Dialog>
  );
}
